import React from "react";
// import useIsSsr from '../../../hooks/use-isSSR'
import InformationDeroulante from "./InformationDeroulante";
import dompurify from 'isomorphic-dompurify';
import {convertExternalEcoSysLinks, dompurifyConfig} from "../../../utils/utils"

import InlineScript from './InlineScript'
import MoreDetails from "./MoreDetails";

import render from "dom-serializer";
import parse from 'html-react-parser';

import {isEcoWebInlineImage,
        isAccordeonDomNode,
        isLinkBoxSticky,
        isScript,
        isShowMoreDomNode,
        nodeToEcoWebInlineImage,
        isAuthorQuote} from './ck-utils'
import AuthorQuote from "./AuthorQuote";

const CkEditor = ({html, lang, elemAnchor}) => {
    const [isClient, setIsClient] = React.useState(false);
    React.useEffect(() => {
        setIsClient(true);
      
        return () => {
            //console.log('cleanup ...')
        }
    }, [])


    const sanitizer = dompurify.sanitize;
    html = convertExternalEcoSysLinks(html)
    html = sanitizer(html, dompurifyConfig)

    const getDisplayLang = () => {
        if (lang) {
            return lang.toLowerCase()
        }
        return undefined
    }

    const domElementHasClass = (el, clazz) => {
        return el && el.attribs && el.attribs.class === clazz 
    }

    const getDomElementText = (el) => { 
        try {
            return render(el.childNodes)
        } catch(e) {
            return ''
        }
    }

    let accIdx = 0
    let stickyBoxindex = 0



    const nodeToInformationDeroulante = (domNode) => {
        accIdx++
        let title, content
        domNode.childNodes.forEach(
            el => {
                
                if (domElementHasClass(el, 'accordeon-title')) {
                    title = getDomElementText(el)
                } else if (domElementHasClass(el, 'accordeon-content')) {
                    content = getDomElementText(el, true)
                }
            }
        )
        return (
            <InformationDeroulante
                key={"accordeon-" + accIdx}
                title={title}
                titleBalise="div"
                content={content}
            />
        )
    }

    const getStickyInnerHtml = (domNode) => {
        if(domNode) {
            try {
                return render(domNode)
            } catch(e) {

            }
        }
        return ''
    }


    const nodeToLinkBoxSticky = (domNode) => {
        stickyBoxindex++
        return (
            <div
                key={"sticky-box-" + stickyBoxindex}
                className="ck-content ck-content-linkbox-sticky"
                dangerouslySetInnerHTML={{__html: getStickyInnerHtml(domNode)}}
            >
            </div>
        )
    }

    const nodeToAuthorQuote = (domNode) => {
        let dta = ['job-position', 'job-position_detail', 'text', 'name']
        let pp = ['jobPosition', 'jobPositionDetail', 'text', 'name']
        let quote = {}
        
        const visitNode = (n) => {
            let cls = n?.attribs?.class
            if (n?.name === 'figure' && n?.attribs?.class === 'image') {
                quote.imageLeft = render(n)
            } else {
                let cidx = dta.indexOf(cls)
                if (cidx !== -1) {
                    quote[pp[cidx]] = render(n.childNodes)
                }
            }
            if (n.childNodes) {
                n.childNodes.forEach(e => {
                    visitNode(e)
                })
            }
        }
    
        visitNode(domNode)

        return (
            <AuthorQuote
                imageCredit={quote.imageCredit}
                imageRight={quote.imageRight}
                imageLeft={quote.imageLeft}
                name={quote.name}
                text={quote.text}
                jobPosition={quote.jobPosition}
                jobPositionDetail={quote.jobPositionDetail}
            />
        )
    }

    const nodeToScriptElement = (domNode) => {
        // allow the script execution browser only 
        if (!isClient) {
            return <></>
        } else {
            return <InlineScript {...domNode}></InlineScript>
        }
    }


    const nodeToMoreDetails = (domNode) => {
        return <MoreDetails data={render(domNode.children)}></MoreDetails>
    }


    const options = {
        
        replace(domNode) {
            if (isShowMoreDomNode(domNode)) {
                return nodeToMoreDetails(domNode)
            }

            if (isAccordeonDomNode(domNode)) {
               return nodeToInformationDeroulante(domNode)
            }

            if (isLinkBoxSticky(domNode)) {
                return nodeToLinkBoxSticky(domNode)
            }

            if (isEcoWebInlineImage(domNode)) {
                return nodeToEcoWebInlineImage(domNode)
            }
            if (isScript(domNode)) {
                return nodeToScriptElement(domNode)
            }
            if (isAuthorQuote(domNode)) {
                return nodeToAuthorQuote(domNode)
            }
        }
    }


    return <div
                lang={getDisplayLang()}
                id={elemAnchor || undefined}
                className="ck-content">
                {parse(html, options)}
            </div>
    
};

export default CkEditor;
